// @flow
import React from 'react';
import { formElement } from '../../../lib/styles';
import { option } from 'fp-ts';
import PopupGallery from '../../media/PopupGallery';
import { pipe } from 'fp-ts/lib/pipeable';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { IconButton } from 'material-ui';
import Photo from 'material-ui/svg-icons/image/photo';
import Preview from '../../preview/Preview';
import { fromNullable } from 'fp-ts/lib/Option';

type ArticlePreviewProps = {
    onValueChange: () => void,
    previewAttribution: string;
    previewPicture: string;
    preview: { id?: string, filename?: string, description?: string },
};

export class ArticlePreview extends React.Component<ArticlePreviewProps> {
    state = {
        isOpened: false,
    };

    render() {
        const { isOpened } = this.state;
        const preview = option.fromNullable(this.props.preview);

        return (
            <div>
                <small style={{ ...formElement.small, display: 'block', marginTop: 19 }}>
                    Фото для превью
                </small>

                {pipe(
                    preview,
                    option.fold(() => (
                        <section
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                padding: '6px 2px 1px 0',
                                borderBottom: 'solid 1px #E0E0E0',
                            }}
                        >
                            <ContentAdd/>
                            <IconButton
                                containerElement="label"
                                style={{ maxWidth: 12, height: 42, padding: 9 }}
                                className="btn__hover_empty"
                                onClick={this.handleClick}
                            >
                                <Photo color="#46bc98" hoverColor="#542376"/>
                            </IconButton>
                        </section>
                    ), (preview) => this.renderPreviewPicture(preview)),
                )}

                <PopupGallery
                    open={isOpened}
                    type={['image', 'video']}
                    closeDialogHandle={this.handleClose}
                    insertMediaFile={(item) => {
                        this.insertMediaFile(item);
                        setTimeout(() => {
                            this.handleClose();
                        }, 250);
                    }}
                    insertAfterUpload
                />
            </div>
        );
    }

    renderPreviewPicture = (preview) => {
        const { previewAttribution, previewPicture } = this.props;
        let previewPath = previewPicture || '';
        let mediaId = '';

        if (preview) {
            previewPath = preview.filename;
            mediaId = preview.id;
        }
        return (<Preview
            item={previewPath}
            mediaId={mediaId}
            attr={previewAttribution || ''}
            showAttr
            setPreviewAttr={this.handlePreviewAttributionChange}
            removePreview={this.handleRemovePreview}
        />);
    }

    handlePreviewAttributionChange = (text) => {
        this.setState({ previewAttribution: text });
        const { preview, onValueChange } = this.props;
        onValueChange(
            pipe(fromNullable(preview), option.map(preview => ({
                ...preview,
                previewAttribution: text
            })))
        )
    }
    

    handleRemovePreview = () => {
        const { onValueChange } = this.props;
        onValueChange(option.none);
    }

    insertMediaFile = (file) => {
        const {onValueChange, previewAttribution} = this.props;
        const fileData = file;

        fileData.type = fileData.type || fileData.fileType;

        onValueChange(option.some({
            id: fileData.id,
            filename: fileData.filename,
            previewAttribution: previewAttribution || fileData.description
        }));
    }

    handleClose = () => {
        this.setState({ isOpened: false });
    }

    handleClick = () => {
        const { edit } = this.props;
        if (!edit) {
            this.setState({
                isOpened: true,
            });
        }
    };
}


// WEBPACK FOOTER //
// src/components/articles/components/ArticlePreview.js